import * as React from 'react';
import { connect } from 'react-redux';
import { Panel, Button, Row } from 'react-bootstrap';
import { handleError } from '../../../../shared/ErrorCatching';
import { Translate } from '../../../../shared/LanguageService';
import * as Features from '../../../../shared/Features';
import TelephoneLink from '../../../../components/common/TelephoneLink';
import { assign } from '../../../../shared/Assign';
import * as Actions from './Actions';
import IOrderAddress from './entities/IOrderPrivatePackageAddress';
import IOrderOwner from './entities/IOrderPrivateOwner';
import IOrderBroker from './entities/IOrderBroker';
import IOrderContactAddress from './entities/IOrderContactAddress';
import OrderAddressModal from './modals/OrderAddressModal';
import OrderOwnerModal from './modals/OrderOwnerModal';
import DefinitionList from '../../../../components/common/DefinitionList';
import DefinitionRow from '../../../../components/common/DefinitionRow';

class ContactAddressPage extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            contactAddress: {
                orderAddress: {},
                orderOwner: {},
                orderBroker: {}
            },
            initialContactAddress: {},
            showAddressModal: false,
            showOwnerModal: false,
            errors: {}
        };
        this.openAddressModal = this.openAddressModal.bind(this);
        this.openOwnerModal = this.openOwnerModal.bind(this);
        this.closeOwnerModal = this.closeOwnerModal.bind(this);
        this.closeAddressModal = this.closeAddressModal.bind(this);
        this.saveAddress = this.saveAddress.bind(this);
        this.saveOwner = this.saveOwner.bind(this);
    }

    componentDidMount(): void {
        this.props.actions
            .getContactAddress(this.props.orderId)
            .catch((error: any) => handleError(error));
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({
            contactAddress: assign({}, nextProps.contactAddress),
            initialContactAddress: assign({}, nextProps.contactAddress)
        });
    }

    openAddressModal(): void {
        this.setState({ showAddressModal: true });
    }

    openOwnerModal(): void {
        this.setState({ showOwnerModal: true });
    }

    closeAddressModal(): void {
        this.setState({
            showAddressModal: false,
            contactAddress: assign({}, this.state.initialContactAddress),
            errors: {}
        });
    }

    closeOwnerModal(): void {
        this.setState({
            showOwnerModal: false,
            contactAddress: assign({}, this.state.initialContactAddress),
            errors: {}
        });
    }

    saveAddress(orderAddress: any): void {
        let contactAddress = this.state.contactAddress;
        contactAddress.orderAddress = orderAddress;
        this.props.actions
            .updateOrderAddress(this.props.orderId, contactAddress)
            .then(() => {
                this.setState({
                    contactAddress: assign({}, contactAddress),
                    initialContactAddress: assign({}, contactAddress),
                    showAddressModal: false,
                    errors: {}
                });
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({
                        errors: errors,
                        creating: false,
                        contactAddress: assign({}, this.state.initialContactAddress)
                    });
                })
            );
    }

    saveOwner(orderOwner: any): void {
        let contactAddress = this.state.contactAddress;
        contactAddress.orderOwner = orderOwner;
        this.props.actions
            .updateOrderOwner(this.props.orderId, contactAddress)
            .then(() => {
                let contactAddress = this.state.contactAddress;
                this.setState({
                    contactAddress: assign({}, contactAddress),
                    initialContactAddress: assign({}, contactAddress),
                    showOwnerModal: false,
                    errors: {}
                });
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({
                        errors: errors,
                        creating: false,
                        contactAddress: assign({}, this.state.initialContactAddress)
                    });
                })
            );
    }

    getFirstAvailableContactPersonName(availableContactPersons: any[], contactPerson) {
        if (availableContactPersons) {
            let first = availableContactPersons.filter((x: any) => x.id === contactPerson)[0];
            if (first) {
                return Translate(first.name);
            }
        }

        return null;
    }

    render() {
        let orderContactAddress: IOrderContactAddress = this.state.contactAddress;
        let orderAddress: IOrderAddress = this.state.contactAddress.orderAddress;
        let orderOwner: IOrderOwner = this.state.contactAddress.orderOwner;
        let orderBroker: IOrderBroker = this.state.contactAddress.orderBroker;
        let objectType: string;

        if (!orderAddress) {
            return <div></div>;
        }

        if (orderContactAddress.isPackageOrder) {
            if (
                !orderContactAddress.isCommercial &&
                orderContactAddress.availablePrivateObjectTypes &&
                orderAddress.objectType !== 0
            ) {
                objectType = Translate(
                    orderContactAddress.availablePrivateObjectTypes.filter(
                        (x: any) => x.id === orderAddress.objectType
                    )[0].name
                );
            } else if (
                orderContactAddress.availableCommercialObjectTypes &&
                orderAddress.objectType !== 0
            ) {
                objectType = Translate(
                    orderContactAddress.availableCommercialObjectTypes.filter(
                        (x: any) => x.id === orderAddress.objectType
                    )[0].name
                );
            }
        }
        return (
            <div>
                <Row className="tabular">
                    <div className="col-sm-4">
                        <Panel>
                            <Panel.Heading>
                                <div>
                                    {!this.props.isArchived &&
                                        Features.hasFeature(
                                            Features.EditOrder,
                                            this.props.user
                                        ) && (
                                            <Button
                                                bsStyle="info"
                                                bsSize="small"
                                                className="btn-edit pull-right"
                                                onClick={this.openAddressModal}
                                            >
                                                <i className="material-icons md-18">edit</i>{' '}
                                                {Translate(
                                                    'view-order/contact/page/panel/button/edit'
                                                )}
                                            </Button>
                                        )}
                                    <h3 className="panel-title">
                                        {Translate('view-order/contact/page/panel/title/address')}
                                    </h3>
                                </div>
                            </Panel.Heading>
                            <Panel.Body>
                                <DefinitionList>
                                    <DefinitionRow 
                                        title={Translate('view-order/contact/page/form/view-label/address-line-1')}
                                        description={orderAddress.addressLine1}
                                    />
                                    <DefinitionRow 
                                        title={Translate('view-order/contact/page/form/view-label/address-city')}
                                        description={orderAddress.addressCity}
                                    />
                                    <DefinitionRow 
                                        title={Translate('view-order/contact/page/form/view-label/address-postal-number')}
                                        description={orderAddress.addressPostalNumber}
                                        display={orderContactAddress.isPackageOrder}
                                    />
                                    <DefinitionRow 
                                        title={Translate('view-order/contact/form/page/view-label/object-type')}
                                        description={objectType}
                                        display={orderContactAddress.isPackageOrder}
                                    />
                                    <DefinitionRow 
                                        title={Translate('view-order/contact/page/form/view-label/address-district')}
                                        description={orderAddress.addressDistrict}
                                        display={orderContactAddress.isPackageOrder && !orderContactAddress.isCommercial}
                                    />
                                    <DefinitionRow 
                                        title={Translate('view-order/contact/page/form/view-label/object-area-square-meters')}
                                        description={orderAddress.objectAreaSquareMeters}
                                        display={orderContactAddress.isPackageOrder && !orderContactAddress.isCommercial}
                                    />
                                    <DefinitionRow 
                                        title={Translate('view-order/contact/page/form/view-label/object-number-of-rooms')}
                                        description={orderAddress.objectNumberOfRooms}
                                        display={orderContactAddress.isPackageOrder && !orderContactAddress.isCommercial}
                                    />
                                    <DefinitionRow 
                                        title={Translate('view-order/contact/page/form/view-label/contact-person')}
                                        description={this.getFirstAvailableContactPersonName(
                                            orderContactAddress.availableContactPersons,
                                            orderAddress.contactPerson
                                        )}
                                        display={orderContactAddress.isPackageOrder && !orderContactAddress.isCommercial}
                                    />
                                    <DefinitionRow 
                                        title={Translate('view-order/contact/page/form/view-label/object-type/apartment/has-balcony')}
                                        description={
                                            orderAddress.apartmentHasBalcony
                                                ? Translate(
                                                    'view-order/contact/page/form/view-label/object-type/apartment/has-balcony/yes'
                                                )
                                                : Translate(
                                                    'view-order/contact/page/form/view-label/object-type/apartment/has-balcony/no'
                                                )
                                        }
                                        display={
                                            orderContactAddress.isPackageOrder 
                                                && !orderContactAddress.isCommercial
                                                && orderAddress.objectType === 1
                                        }
                                    />
                                    <DefinitionRow 
                                        title={Translate('view-order/contact/page/form/view-label/object-type/apartment/floor')}
                                        description={orderAddress.apartmentFloor}
                                        display={
                                            orderContactAddress.isPackageOrder 
                                                && !orderContactAddress.isCommercial
                                                && orderAddress.objectType === 1
                                        }
                                    />
                                    <DefinitionRow 
                                        title={Translate('view-order/contact/page/form/view-label/object-type/apartment/access-code')}
                                        description={orderAddress.apartmentAccessCode}
                                        display={
                                            orderContactAddress.isPackageOrder 
                                                && !orderContactAddress.isCommercial
                                                && orderAddress.objectType === 1
                                        }
                                    />
                                </DefinitionList>
                            </Panel.Body>
                        </Panel>
                    </div>
                    {orderContactAddress.isPackageOrder && (
                        <div className="col-sm-4">
                            <Panel>
                                <Panel.Heading>
                                    <div>
                                        {!this.props.isArchived &&
                                            Features.hasFeature(
                                                Features.EditOrder,
                                                this.props.user
                                            ) && (
                                                <Button
                                                    bsStyle="info"
                                                    bsSize="small"
                                                    className="btn-edit pull-right"
                                                    onClick={this.openOwnerModal}
                                                >
                                                    <i className="material-icons md-18">edit</i>
                                                    {Translate(
                                                        'view-order/contact/page/panel/button/edit'
                                                    )}
                                                </Button>
                                            )}
                                        <h3 className="panel-title">
                                            {Translate(
                                                'view-order/contact/page/panel/title/owner-info'
                                            )}
                                        </h3>
                                    </div>
                                </Panel.Heading>
                                <Panel.Body>
                                    <DefinitionList>
                                        <DefinitionRow 
                                            title={Translate('view-order/contact/page/form/view-label/owner-first-name')}
                                            description={orderOwner.ownerFirstName}
                                        />
                                        <DefinitionRow 
                                            title={Translate('view-order/contact/page/form/view-label/owner-last-name')}
                                            description={orderOwner.ownerLastName}
                                        />
                                        <DefinitionRow 
                                            title={Translate('view-order/contact/page/form/view-label/owner-primary-phone-number')}
                                            description={orderOwner.ownerPrimaryPhoneNumber}
                                            isTelephoneLink
                                        />
                                        <DefinitionRow 
                                            title={Translate('view-order/contact/page/form/view-label/owner-secondary-phone-number')}
                                            description={orderOwner.ownerSecondaryPhoneNumber}
                                            display={!orderContactAddress.isCommercial}
                                            isTelephoneLink
                                        />
                                        <DefinitionRow 
                                            title={Translate('view-order/contact/page/form/view-label/owner-email')}
                                            description={orderOwner.ownerEmailAddress}
                                            isTelephoneLink
                                        />
                                    </DefinitionList>
                                </Panel.Body>
                            </Panel>
                        </div>
                    )}
                    <div className="col-sm-4">
                        <Panel>
                            <Panel.Heading>
                                <h3 className="panel-title">
                                    {Translate('view-order/contact/page/panel/title/broker-info')}
                                </h3>
                            </Panel.Heading>
                            <Panel.Body>
                                <DefinitionList>
                                    <DefinitionRow
                                        title={Translate('view-order/contact/page/form/view-label/broker/name')}
                                        description={orderBroker.brokerName}
                                    />
                                    <DefinitionRow
                                        title={Translate('view-order/contact/page/form/view-label/broker/phone-number')}
                                        description={orderBroker.brokerPhoneNumber}
                                        isTelephoneLink
                                    />
                                    <DefinitionRow
                                        title={Translate('view-order/contact/page/form/view-label/broker/email')}
                                        description={orderBroker.brokerEmail}
                                    />
                                </DefinitionList>
                            </Panel.Body>
                        </Panel>
                    </div>
                </Row>
                {this.state.showAddressModal && (
                    <OrderAddressModal
                        shouldShowModal={this.state.showAddressModal}
                        closeModal={this.closeAddressModal}
                        orderAddress={orderAddress}
                        isCommercial={orderContactAddress.isCommercial}
                        isPackageOrder={orderContactAddress.isPackageOrder}
                        availableCommercialObjectTypes={
                            orderContactAddress.availableCommercialObjectTypes
                        }
                        availablePrivateObjectTypes={
                            orderContactAddress.availablePrivateObjectTypes
                        }
                        availableContactPersons={orderContactAddress.availableContactPersons}
                        save={this.saveAddress}
                        errors={this.state.errors}
                    />
                )}
                {this.state.showOwnerModal && (
                    <OrderOwnerModal
                        shouldShowModal={this.state.showOwnerModal}
                        closeModal={this.closeOwnerModal}
                        orderOwner={orderOwner}
                        isCommercial={orderContactAddress.isCommercial}
                        save={this.saveOwner}
                        errors={this.state.errors}
                    />
                )}
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        order: state.viewOrder,
        contactAddress: state.viewOrderContact.orderContactAddress,
        user: state.user
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getContactAddress: (id: number) => dispatch(Actions.getContactAddress(id)),
            updateOrderAddress: (id: number, orderContactAddress: IOrderContactAddress) =>
                dispatch(Actions.updateOrderAddress(id, orderContactAddress)),
            updateOrderOwner: (id: number, orderContactAddress: IOrderContactAddress) =>
                dispatch(Actions.updateOrderOwner(id, orderContactAddress))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactAddressPage);
